import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const Component = () => {
  const { t } = useTranslation();

  return (
    <Text ta="justify">
      Muchas gracias. Estamos por terminar. A continuación, te realizaremos unas
      preguntas sobre el tratamiento de casos de acoso y/o violencia en el
      trabajo dentro de tu organización. Recuerda que todas tus respuestas son
      totalmente anónimas y confidenciales.
    </Text>
  );
};

export default Component;
